<div fxLayout="row" fxLayoutAlign="center center">
  <div fxLayout="column" fxFlex="40%" fxFlex.sm="80%" fxFlex.md="80%" fxFlex.xs="90%"
    fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
    <br />
    <br />
    <h1 class="mat-h1" i18n="@@screener-header" name="screener-header"><b>Screener</b></h1>

    <mat-vertical-stepper class="mat-elevation-z4" [linear]="isLinear" labelPosition="bottom" #stepper>
      <mat-step>
        <ng-template matStepLabel name="step-label-instructions">
          <span i18n="@@step-label-instructions" id="titleInstructions">What is a screener?</span>
        </ng-template>
  
        <div class="instructions">
          <p i18n="@@instructions-1" name="instructions-1">Wales Essential Skills Toolkit gives you
            opportunities
            to improve your
            communication and
            number skills.</p>
          <p i18n="@@instructions-2" name="instructions-2">Screeners are short tests to give you a rough guide
            to
            your current skills
            level.</p>
          <p i18n="@@instructions-3" name="instructions-3">There are 15 questions in a screener, and a
            separate
            screener for each of our
            courses.</p>
          <p i18n="@@instructions-4" name="instructions-4">To begin, enter your details below, then press the
            next
            button to reveal the
            screener links.</p>
          <p i18n="@@instructions-5" name="instructions-5">At the end of your screener, be sure to print your
            result so you can keep a
            record of how
            well you did.</p>
        </div>

        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          <button id="btnNextInstruction" mat-raised-button color="primary" matStepperNext i18n="@@step-button-next"
            name="step-button-next">Next</button>
        </div>
      </mat-step>
      <mat-step [stepControl]="screenerFormGroup">
        <form [formGroup]="screenerFormGroup">
          <ng-template matStepLabel name="step-label-details">
            <span i18n="@@step-label-details" id="titleForm">Provide your details</span>
          </ng-template>
          <div id="courseForm" fxLayout="column">
            <mat-form-field [class.long-error-message]="firstName.errors?.minlength || firstName.errors?.maxlength">
              <mat-label i18n="@@step-form-firstName" name="step-form-firstName">First Name</mat-label>
              <input matInput formControlName="firstName" required>
              <mat-error i18n="@@firstName-required" name="firstName-required" *ngIf="firstName.errors?.required">
                First Name is required.
              </mat-error>
              <mat-error i18n="@@firstName-invalid-character" name="firstName-invalid-character" *ngIf="firstName.errors?.pattern">
                First Name contains invalid characters.
              </mat-error>
              <mat-error i18n="@@firstName-character-length" name="firstName-character-length" 
                *ngIf="firstName.errors?.minlength || firstName.errors?.maxlength">
                The field first name must be between 2 and 64 characters.
              </mat-error>
            </mat-form-field>

            <mat-form-field [class.long-error-message]="lastName.errors?.minlength || lastName.errors?.maxlength">
              <mat-label i18n="@@step-form-lastName" name="step-form-lastName">Last Name</mat-label>
              <input matInput formControlName="lastName" required>
              <mat-error i18n="@@lastName-required" name="lastName-required" *ngIf="lastName.errors?.required">
                Last Name is required.
              </mat-error>
              <mat-error i18n="@@lastName-character-length" name="lastName-character-length" 
                *ngIf="lastName.errors?.minlength || lastName.errors?.maxlength">
                The field last name must be between 2 and 64 characters.
              </mat-error>
              <mat-error i18n="@@lastName-invalid-character" name="lastName-invalid-character" *ngIf="lastName.errors?.pattern">
                Last Name contains invalid characters.
              </mat-error>
            </mat-form-field>

            <mat-form-field [class.long-error-message]="email.errors?.minlength || email.errors?.maxlength">
              <mat-label i18n="@@email" name="step-form-email">Email</mat-label>
              <input type="email" matInput formControlName="email" required noWhiteSpaces>
              <mat-error i18n="@@email-validation" name="email-validation" *ngIf="email.errors?.pattern">
                Please enter a valid email address.
              </mat-error>
              <mat-error i18n="@@email-required" name="email-required" *ngIf="email.errors?.required">
                Email is required.
              </mat-error>
              <mat-error i18n="@@email-character-length" name="email-character-length" 
                *ngIf="email.errors?.minlength || email.errors?.maxlength">
                The field email must be between 2 and 100 characters.
              </mat-error>
            </mat-form-field>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
              <button id="btnBackForm" mat-raised-button color="primary" matStepperPrevious i18n="@@step-button-back"
                name="step-button-back">Back</button>
              <button id="btnNextForm" mat-raised-button color="primary" matStepperNext i18n="@@step-button-next"
                name="step-button-next" (click)="getCourseByEmail()">Next</button>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="coursesFormGroup">
        <ng-template matStepLabel name="step-label-course">
          <span i18n="@@step-label-course" id="titleCourse">Choose a course</span>
        </ng-template>
        <br />
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="space-around baseline">
          <app-loading-page *ngIf="courseLoader else coursesTemplate"></app-loading-page>
          <ng-template #coursesTemplate>
            <ng-container *ngFor="let course of courses">
              <mat-card fxFlex="40%" fxLayout="row wrap" fxLayoutAlign="center center" class="mat-elevation-z4">
                <img mat-card-image class="course-img" src={{course.iconPath}} alt={{course.name}}>
                <div class="float-button">
                  <button *ngIf="course.screenerResult === null" i18n="@@screener-start-btn" name="screener-start-btn" mat-raised-button color="primary"
                    [disabled]="isSaving" (click)="saveScreenerDetails(course.screenerObjectId)">Start</button>
                </div>
                <mat-progress-bar mat-card-image mode="indeterminate"
                  *ngIf="isSaving && selectedCourse == course.screenerObjectId"></mat-progress-bar>
                <mat-card-content fxFlex="100%" fxLayout="column" fxLayoutAlign="space-around stretch">
                  <h3 *ngIf="course.screenerResult === null" name="course-name" class="p-10"><b>{{course.name}}</b></h3>
                  <mat-expansion-panel *ngIf="course.screenerResult !== null" class="mat-elevation-z0" [expanded]="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <h3 name="course-name"><b>{{course.name}}</b></h3>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                      <p i18n="@@screener-result-level" name="screener-result-level"><br />Your screener answers suggested
                          that you were working towards
                          <span>{{course.screenerResult.overallResult | titlecase}}</span>
                          in {{course.name}}.
                      </p>
                      <div fxLayout="column" fxLayoutAlign="start stretch" fxFlexAlign="center" fxFlexAlign.xs="center">
                          <span i18n="@@screener-result-date-completed" name="screener-result-date-completed"
                              class="date-completed text-grey">Date completed:
                              <i>{{course.screenerResult.dateCompleted | date:'d MMM y'}}</i></span>
                          <p i18n="@@screener-result-total-time" name="screener-result-total-time"
                              class="total-time text-grey">
                              <span>Total time taken: </span><i>{{course.screenerResult.totalTime}}</i></p>
                      </div>
                  </mat-expansion-panel>
                </mat-card-content>
              </mat-card>
            </ng-container>
          </ng-template>
        </div>
        <br />
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          <button id="btnBackCourse" mat-raised-button color="primary" matStepperPrevious i18n="@@step-button-back"
            name="step-button-back">Back</button>
        </div>
      </mat-step>
    </mat-vertical-stepper>
  </div>
</div>